export default {"src":"https://fishbrain.com/_next/static/media/newMexico.90abdf21.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};